import ProfileMenu from './components/ProfileMenu';
import { ImportProgressPill } from 'components/ImportProgressPill';
import './TopNavigationBar.css';
import { useState, useEffect } from 'react';

interface Props {
  title: string;
  isMobileMenuOpen?: boolean;
  onToggleMobileMenu?: () => void;
}

export const TopNavigationBar = ({ title, isMobileMenuOpen, onToggleMobileMenu }: Props) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  return (
    <div className="top-navigation-bar">
      {/* Mobile Hamburger Button */}
      {isMobile && onToggleMobileMenu && (
        <button 
          className={`mobile-hamburger ${isMobileMenuOpen ? 'open' : ''}`}
          onClick={onToggleMobileMenu}
          aria-label="Toggle navigation menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      )}
      
      <div className="top-navigation-bar-title">{title}</div>
      <ImportProgressPill />
      <ProfileMenu />
    </div>
  );
};
